import * as xlsx from "xlsx";

export const INCOME_PER_TICKET = 12;
export const ticketCount = (order) => Number(order.size) || 0;

export function summarizeAffiliates(orders) {
  const groups = new Map();
  orders.forEach((order) => {
    const id = String(order.referrer);
    if (!groups.has(id)) groups.set(id, { id, orders: [], tickets: 0 });
    const group = groups.get(id);
    group.orders.push(order);
    group.tickets += ticketCount(order);
  });
  return [...groups.values()].sort((a, b) => a.id.localeCompare(b.id, "en", { numeric: true }));
}

export function createAffiliateWorkbook(orders, roundDate) {
  const groups = summarizeAffiliates(orders);
  const tickets = groups.reduce((total, group) => total + group.tickets, 0);
  const title = [`รายงานรายได้ชวนเพื่อน งวด ${roundDate}`];
  const note = [`รายได้คำนวณ ${INCOME_PER_TICKET} บาทต่อใบ (ไม่ใช่ยอดโอนเงินจริง)`];
  const summary = [title, note, [],
    ["ลำดับที่", "รหัสผู้แนะนำ", "จำนวนคำสั่งซื้อ", "จำนวนสลาก (ใบ)", "รายได้คำนวณ (บาท)"],
    ...groups.map((group, index) => [index + 1, group.id, group.orders.length, group.tickets, group.tickets * INCOME_PER_TICKET]),
    ["รวมทั้งหมด", "", orders.length, tickets, tickets * INCOME_PER_TICKET],
  ];
  const detail = [title, note, [],
    ["ลำดับที่", "รหัสผู้แนะนำ", "รหัสคำสั่งซื้อ", "รหัสผู้ซื้อ", "จำนวนสลาก (ใบ)", "รายได้คำนวณ (บาท)"],
    ...groups.flatMap((group) => group.orders).map((order, index) => [index + 1, String(order.referrer), String(order.shortId || order.id || "-"), String(order.userId ?? "-"), ticketCount(order), ticketCount(order) * INCOME_PER_TICKET]),
    ["รวมทั้งหมด", "", "", "", tickets, tickets * INCOME_PER_TICKET],
  ];
  const workbook = xlsx.utils.book_new();
  [["สรุปผู้แนะนำ", summary, [12, 22, 24, 24, 26]], ["รายละเอียดคำสั่งซื้อ", detail, [12, 22, 24, 22, 24, 26]]].forEach(([name, rows, widths]) => {
    const sheet = xlsx.utils.aoa_to_sheet(rows);
    sheet["!cols"] = widths.map((wch) => ({ wch }));
    sheet["!autofilter"] = { ref: xlsx.utils.encode_range({ r: 3, c: 0 }, { r: rows.length - 2, c: widths.length - 1 }) };
    xlsx.utils.book_append_sheet(workbook, sheet, name);
  });
  return workbook;
}
